import classicImg from '@/assets/classic-package.jpg';
import majesticImg from '@/assets/majestic-package.jpg';
import royalImg from '@/assets/royal-package.jpg';
import twilightImg from '@/assets/twilight-package.jpg';

export interface BookingPackage {
  id: string;
  name: string;
  price: number;
  image: string;
  features: string[];
}

export interface BookingFormData {
  packageId: string;
  guests: number;
  date: Date;
}

export interface PaymentFormData extends BookingFormData {
  name: string;
  email: string;
  phone: string;
}

export const PACKAGES: BookingPackage[] = [
  {
    id: 'classic',
    name: 'Standard Package',
    price: 599,
    image: classicImg,
    features: [
      '🚐 Pick & drop within Dubai',
      '☕ Unlimited Tea/Coffee & Water at take-off point',
      '🎈 Hot Air Balloon (45–60 min)',
      '📜 Flight certificate signed by Pilot'
    ]
  },
  {
    id: 'majestic',
    name: 'Deluxe Package',
    price: 699,
    image: majesticImg,
    features: [
      '🚐 Pick & drop within Dubai',
      '☕ Tea/Coffee & Water before take-off',
      '🍽 Gourmet Breakfast at camp',
      '🐪 Camel Ride (5–10 min)',
      '🦅 Falcon Photo',
      '🎈 Hot Air Balloon (45–60 min)',
      '📜 Flight certificate signed by Pilot'
    ]
  },
  {
    id: 'royal',
    name: 'Premium Package',
    price: 1550,
    image: royalImg,
    features: [
      '🚐 Pick & drop within Dubai',
      '☕ Tea/Coffee & Water at take-off point',
      '🍽 Gourmet Buffet Breakfast at camp',
      '🐪 Camel Ride (5–10 min)',
      '🏍 Quad Biking (10–15 min)',
      '🏜 Dune Bashing (15–20 min)',
      '🦅 Falcon Photo',
      '🎈 Hot Air Balloon (45–60 min)',
      '📜 Flight certificate signed by Pilot'
    ]
  },
  {
    id: 'twilight',
    name: 'Overnight Package',
    price: 1950,
    image: twilightImg,
    features: [
      '🚗 Private Pick & Drop (Dubai City)',
      '🕒 Day 1 Pickup: 03:00–03:30 PM',
      '🏜 Dune Bashing (20 min)',
      '☕ Welcome Drinks + Dates & Arabic Sweets',
      '🐪 Camel Ride + 🦅 Falcon Photo + 🎨 Henna',
      '💃 Live Shows (Belly, Tanura, Fire)',
      '🍖 BBQ Dinner + Unlimited Soft Drinks',
      '🏕 Overnight Camp Stay',
      '🕓 Day 2 Pickup 04:00 AM to Balloon Point',
      '☕ Tea/Coffee & Water at take-off',
      '🍽 Gourmet Breakfast',
      '🎈 Hot Air Balloon (45–60 min)',
      '📜 Flight certificate signed by Pilot'
    ]
  }
];
